const decodeBase64Url = (value) => {
    const rawValue = String(value || '');
    const base64 = rawValue
        .replace(/-/g, '+')
        .replace(/_/g, '/')
        .padEnd(Math.ceil(rawValue.length / 4) * 4, '=');

    return decodeURIComponent(
        atob(base64)
            .split('')
            .map((char) => `%${(`00${char.charCodeAt(0).toString(16)}`).slice(-2)}`)
            .join('')
    );
};

export const decodeAccessToken = (accessToken) => {
    try {
        const [, payload] = String(accessToken || '').split('.');
        if (!payload) {
            return null;
        }

        return JSON.parse(decodeBase64Url(payload));
    } catch (error) {
        console.error('Error decoding access token:', error);
        return null;
    }
};

export const isAccessTokenExpired = (claims) => {
    if (!claims?.exp) {
        return false;
    }

    return Number(claims.exp) * 1000 <= Date.now();
};
